import { render, staticRenderFns } from "./TestPackageServerTable.vue?vue&type=template&id=50c58964"
import script from "./TestPackageServerTable.vue?vue&type=script&lang=js"
export * from "./TestPackageServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports